import React, { useEffect, useState } from 'react';
import { Redirect, useLocalSearchParams } from 'expo-router';
import { useCasesApi } from '@/lib/api/useCases';
import ChurchesPage from '@/components/Pages/ChurchesPage.web';
import UseCaseEditorial from '@/components/Pages/UseCaseEditorial.web';
import UseCasePageSkeleton from '@/components/Landing/UseCasePageSkeleton';

export default function UseCasePage() {
  const { slug } = useLocalSearchParams();
  const slugKey = typeof slug === 'string' ? slug : (Array.isArray(slug) ? slug[0] : '');
  const [useCase, setUseCase] = useState(null);
  const [relatedUseCases, setRelatedUseCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let alive = true;
    if (slugKey === 'churches') return undefined;
    if (!slugKey) {
      setLoading(false);
      setNotFound(true);
      return undefined;
    }

    setLoading(true);
    setNotFound(false);

    (async () => {
      try {
        const data = await useCasesApi.getBySlug(slugKey);
        if (!alive) return;
        if (!data?.useCase) {
          setNotFound(true);
          return;
        }
        setUseCase(data.useCase);
        setRelatedUseCases(Array.isArray(data.relatedUseCases) ? data.relatedUseCases : []);
      } catch {
        if (!alive) return;
        setNotFound(true);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => { alive = false; };
  }, [slugKey]);

  if (slugKey === 'churches') return <ChurchesPage />;

  if (loading) {
    return <UseCasePageSkeleton />;
  }

  if (notFound || !useCase) {
    return <Redirect href="/use-cases" />;
  }

  return <UseCaseEditorial key={slugKey} data={useCase} relatedUseCases={relatedUseCases} />;
}
